import {clientUrlPrefix} from "./settings";
import IAction from "./IAction";

export function throttle(firstFunc, throttingFunc, ms: number = 2000): Function {
    // source (modified): https://javascript.info/task/throttle

    let isThrottled = false;

    function wrapper() {

        if (isThrottled) { // (2)
            throttingFunc.apply(this, arguments);
            return;
        }

        firstFunc.apply(this, arguments); // (1)

        isThrottled = true;

        setTimeout(function() {
            isThrottled = false; // (3)
        }, ms);
    }

    return wrapper;
}

export function countSeqsInFasta(fasta: string): number {
    const m = fasta.match(/^>/gm);
    return m ? m.length : 0;
}

export function debounce(func, delay: number) {
    let currTimeout = null;
    return [
        function() {
            const context = this;
            const args = arguments;
            if (currTimeout !== null) {
                clearTimeout(currTimeout);
            }
            currTimeout = setTimeout(() => func.apply(context, args), delay);
        },
        function() {
            const context = this;
            const args = arguments;
            if (currTimeout !== null) {
                clearTimeout(currTimeout);
            }
            func.apply(context, args);
        }
    ];
}

export function ll_fetch(url: string, options?: RequestInit) {
    return fetch(clientUrlPrefix + url, options)
}

export function ll_download_data_with_actions<T>(
    dispatch: any,
    url: string,
    requestActFn: () => IAction,
    failureActFn: () => IAction,
    successActFn: (data: T) => IAction,
    successCallback?: (data: T) => void,
) {
    dispatch(requestActFn());
    ll_fetch(url)
    .then(response => {
        if (response.ok) {
            response.json()
            .then(data => {
                dispatch(successActFn(data));
                if (successCallback !== undefined) {
                    successCallback(data);
                }
            })
            .catch(err => {
                dispatch(failureActFn());
                console.error(err);
            })
        } else {
            dispatch(failureActFn());
        }
    })
    .catch(err => {
        dispatch(failureActFn());
        console.error(err);
    })
}

export function ll_url(url: string) {
    return clientUrlPrefix + url;
}

export function equalArray<T> (
        foo: Array<T>,
        bar: Array<T>,
        equalItemFn?: (fooItem: T, barItem: T) => boolean
): boolean {
    if (foo === bar) {
        return true;
    }
    if (foo.length !== bar.length) {
        return false;
    }
    if (equalItemFn === undefined) {
        equalItemFn = (fooItem: T, barItem: T) => fooItem === barItem;
    }
    const len = foo.length;
    for (let i = 0; i < len; i++) {
        if (equalItemFn(foo[i], bar[i]) === false) {
            return false;
        }
    }
    return true;
}

export function equalArrayUnsorted<T>(foo: Array<T>, bar: Array<T>): boolean {
    return (
        foo === bar ||
        equalArray(
            foo.slice().sort(),
            bar.slice().sort(),
        )
    );
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
export function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
